module.exports = __webpack_public_path__ + "static/media/galaxy_01.de7c2c2d.png";